import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/spices.css';
import spices from '../data/data';
import { useTranslation } from 'react-i18next';

function Spices() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 12; // products per page

  // Filter products
  const filteredSpices = spices.filter((spice) => {
    const translatedName = t(spice.nameKey).toLowerCase();
    const originalName = spice.name.toLowerCase();
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const matchesSearch =
      translatedName.includes(lowerCaseSearchTerm) ||
      originalName.includes(lowerCaseSearchTerm);
    const matchesType =
      selectedType === "all" || spice.typeKey === selectedType;
    return matchesSearch && matchesType;
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredSpices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSpices = filteredSpices.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll to top
    }
  };

  return (
    <div>
      <div
        className="bg"
        style={{
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
        }}
      >
        <div className="search-filter-container">
          <input
            type="text"
            placeholder={t('search_spices')}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // reset to page 1 when searching
            }}
            className="search-input"
          />
          <select
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e.target.value);
              setCurrentPage(1); // reset to page 1 when filtering
            }}
            className="type-select"
          >
            <option value="all">{t('all')}</option>
            <option value="pickle">{t('pickle')}</option>
            <option value="herbs">{t('herbs')}</option>
            <option value="ground_spice">{t('ground_spice')}</option>
            <option value="whole_spice">{t('whole_spice')}</option>
          </select>
        </div>

        <div className="bg-container">
          <div className="spice-grid">
            {currentSpices.length > 0 ? (
              currentSpices.map((spice, index) => (
                <div
                  className="spice-card"
                  key={index}
                  onClick={() => navigate(`/spice/${spice.name}`)}
                >
                  <img
                    src={spice.image}
                    alt={t(spice.nameKey)}
                    className="spice-img"
                    loading={index < 4 ? 'eager' : 'lazy'}
                  />
                  <h3>{t(spice.nameKey)}</h3>
                  <p>{t(spice.descriptionKey).slice(0, 100)}...</p>
                </div>
              ))
            ) : (
              <p className="no-results">{t('no_spices_found')}</p>
            )}
          </div>
        </div>

        {/* Pagination controls */}
        {filteredSpices.length > itemsPerPage && (
          <div className="pagination">
            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              {t('prev')}
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => goToPage(i + 1)}
                className={currentPage === i + 1 ? 'active' : ''}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              {t('next')}
            </button>
          </div>
        )}
      </div>

      <div className="footer">
        <p className="foot-head">{t('company_name_full')}</p>
        <p>No: 37/953, 24th Main, JP Nagar II Phase, Bangalore-560078</p>
        <p>
          {t('all_rights_reserved', { year: new Date().getFullYear() })}
        </p>
      </div>
    </div>
  );
}

export default Spices;
